// roles.js
import {
    Gauge,
    LayoutGrid,
    Calendar,
    NotebookPen,
    Layers,
    BarChart,
    Hourglass,
    Users,
    //Clients, 
    Settings,
    HelpCircle,
    ChevronsLeft,
    ChevronsRight,
    LogOut,
    User,
    PlusSquare,
    Package,
    FileText,
    FolderTree,
    FileJson,
    Logs, Webhook, Milestone,
    ListChecks,
    Repeat,
    Activity,
    Puzzle,
    ShieldCheck,
    Plug,
    CreditCard,
    Wrench,
    FolderGit2,
    FileSearch,
    Cpu,
    GitBranch,
    Database,
    FlaskConical,
    Cog
} from 'lucide-react';


export const menuItems = [
    {
        icon: Gauge,
        name: 'Dashboard',
        path: '/admin/dashboard',
        permission: 'dashboard_admin'
    },
    {
        icon: NotebookPen,
        name: 'MLM Uploader',
        path: '/admin/fieldupdate',
        permission: 'bulk_update_fields'
    },
    {
        icon: PlusSquare,
        name: 'Encompass Uploader',
        path: '/admin/losfieldupdate',
        permission: 'encompass_fieldupdate'
    },
    {
        icon: Puzzle,
        name: 'HouseCanary Data',
        path: '/admin/hc',
        permission: 'housecanary_api'
    },
    {
        icon: Plug,
        name: 'SiteXPro Data',
        path: '/admin/sx',
        permission: 'sitexpro_api'
    },
    {
        icon: BarChart,
        name: 'Consolidated Property View',
        path: '/admin/consolidatedpropertyview',
        permission: 'consolidated_property_view'
    },
    {
        icon: CreditCard,
        name: 'Auto Loan Submission',
        path: '/admin/autoloansubmission',
        permission: 'autoloansubmit_api'
    },
    {
        icon: FolderGit2,
        name: 'Loan Folder Movement',
        path: '/admin/loanfoldermovement',
        permission: 'loan_folder_movement'
    },
    {
        icon: CreditCard,
        name: 'Automated CU Review',
        path: '/admin/automatedcureview',
        permission: 'automated_cu_review'
    },
    {
        icon: ListChecks,
        name: 'Rule Execution Results',
        path: '/admin/ruleexecutionresults',
        permission: 'rule_execution_results'
    },
     {
        icon: FileSearch,
        name: 'Document Review',
        path: '/admin/docreview',
        permission: 'document_review'
    },
    {
        icon: Cpu,
        name: 'Manage Rule Engine',
        permission: 'rule_engine',
        children: [
            // {
            //     icon: Gauge,
            //     name: 'Dashboard',
            //     path: '/admin/ruleengine/dashboard',
            //     permission: 'rule_engine'
            // },
            // {
            //     icon: FileText,
            //     name: 'Normal Rules',
            //     path: '/admin/ruleengine/normal-rules',
            //     permission: 'rule_engine'
            // },
            // {
            //     icon: GitBranch,
            //     name: 'Condition Rules',
            //     path: '/admin/ruleengine/condition-rules',
            //     permission: 'rule_engine'
            // },
            // {
            //     icon: Database,
            //     name: 'Condition Catalog',
            //     path: '/admin/ruleengine/condition-catalog',
            //     permission: 'rule_engine'
            // },
            // {
            //     icon: Package,
            //     name: 'Releases',
            //     path: '/admin/ruleengine/releases',
            //     permission: 'rule_engine'
            // },
            {
                icon: FlaskConical,
                name: 'Testing Console',
                path: '/admin/ruleengine/testing',
                permission: 'rule_engine'
            },
            // {
            //     icon: Cog,
            //     name: 'Operations',
            //     path: '/admin/ruleengine/operations',
            //     permission: 'rule_engine'
            // }
        ]
    },
    {
        icon: Settings,
        name: 'Settings',
        permission: 'admin_settings', // Parent permission
        children: [
            {
                icon: User,
                name: 'Manage Users',
                path: '/admin/manageusers',
                permission: 'manage_users'
            },
            {
                icon: ShieldCheck,
                name: 'Permission Mapping',
                path: '/admin/rolepermission',
                permission: 'permission_mapping'
            },
            {
                icon: ListChecks,
                name: 'Rules',
                path: '/admin/rules',
                permission: 'rules_admin' // TODO: grant this permission to appropriate roles
            },
            {
                icon: ListChecks,
                name: 'Rule Engine Version',
                path: '/admin/ruleengineversion',
                permission: 'rules_admin'
            },
              {
                icon: Wrench,
                name: 'Org Configuration',
                path: '/admin/orgconfig',
                permission: 'org_configuration' // TODO: grant this permission to appropriate roles
            },
             
            {
                icon: LayoutGrid,
                name: 'Batch',
                permission: 'batch',
                children: [
                    {
                        icon: Layers,
                        name: 'Types',
                        path: '/admin/batches',
                        permission: 'batch'
                    },
                    {
                        icon: FolderTree,
                        name: 'Field Categories',
                        path: '/admin/batchfieldcategory',
                        permission: 'batch_fields_category'
                    },
                    {
                        icon: FileText,
                        name: 'Fields',
                        path: '/admin/batchfields',
                        permission: 'batch_fields'
                    },
                    {
                        icon: FileJson,
                        name: 'Import',
                        path: '/admin/batchimport',
                        permission: 'batch_import'
                    },
                    {
                        icon: FileText,
                        name: 'Rule Fields',
                        path: '/admin/rulefields',
                        permission: 'rules_admin'
                    },
                ]
            },
            {
                icon: Package,
                name: 'Utilities',
                path: '/admin/utilities',
                permission: 'service_utilities'
            }
        ]
    },
    {
        icon: Logs,
        name: 'Encompass Audit',
        permission: 'admin_settings', // Parent permission
        children: [
            {
                icon: Calendar,
                name: 'Loan Events',
                path: '/admin/loanevents',
                permission: 'loan_events'
            },
            {
                icon: Hourglass,
                name: 'Audit Trail',
                path: '/admin/timelineview',
                permission: 'audit_view'
            },
            {
                icon: Webhook,
                name: 'Polly Events',
                path: '/admin/pollyevents',
                permission: 'polly_view'
            },
            {
                icon: Milestone,
                name: 'Loan Snapshot',
                path: '/admin/loansnapshot',
                permission: 'milestone_view'
            },
            {
                icon: Activity,
                name: 'Condition Snapshot',
                path: '/admin/conditionsnapshot',
                permission: 'condition_view'
            },
            {
                icon: ListChecks,
                name: 'Tasks',
                path: '/admin/tasks',
                permission: 'loan_tasks'
            },
            {
                icon: Repeat,
                name: 'Webhook Reprocess',
                path: '/admin/reprocessing',
                permission: 'webhook_reprocessing'
            },
            {
                icon: Repeat,
                name: 'Attachment Reprocess',
                path: '/admin/attachmentreprocessing',
                permission: 'attachment_reprocessing'
            },
            {
                icon: ListChecks,
                name: 'Encompass Integration',
                path: '/admin/encompassintegration',
                permission: 'encompass_integration' // TODO: grant this permission to appropriate roles
            }
        ]
    }
];

